import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    button: {
        display: "flex",
        width: "fit-content",
        padding: `${rem(8)} ${rem(12)}`,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: rem(4),
        background: "white",
        border: `1px solid ${theme.colors.gray[3]}`,

        color: theme.colors.gray[7],
        fontSize: rem(14),
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: rem(14),
        gap: rem(6),

        "&:hover": {
            backgroundColor: theme.colors.gray[1],
            color: theme.colors.gray[7],
        },
    },
}))
